/* Cart protection upsell (Prestige build, Etozil + Platomer). Ported from the Noirski/Viruxi build (assets/package-protection.js).
   Variant id comes from the script tag: <script src=".../package-protection.js" data-variant-id="..."> (layout/theme.liquid).
   Default ON: added when the number of real products rises (and once on load when the cart already holds products and the
   visitor did not opt out). Opt-out lives in sessionStorage. Removed again when no real product is left.
   The protection line never counts as a product: the header cart count shows real products only. */
(function () {
  const me = document.currentScript;
  const VID = Number(me && me.dataset.variantId);
  if (!VID) return;
  const SWITCH_SELECTOR = '.pp-input';
  const SAFETY_UNLOCK_MS = 15000;
  const OPT_OUT_KEY = 'package_protection_opt_out';
  const ON_CART_PAGE = /\/cart\/?$/.test(location.pathname);

  let previousNormalItemCount = 0;
  let hasInitialized = false;
  let activeOperations = 0;
  let safetyUnlockTimer = null;
  let normalCountShown = null;
  let changedByUs = false;

  function autoAddAllowed() { try { return sessionStorage.getItem(OPT_OUT_KEY) !== '1'; } catch (e) { return false; } }
  function rememberChoice(isOn) { try { if (isOn) sessionStorage.removeItem(OPT_OUT_KEY); else sessionStorage.setItem(OPT_OUT_KEY, '1'); } catch (e) {} }
  const isProcessing = () => activeOperations > 0;

  function applyLockState() {
    const locked = isProcessing();
    document.querySelectorAll(SWITCH_SELECTOR).forEach((s) => {
      s.disabled = locked;
      const label = s.closest('.pp-switch');
      if (label) label.classList.toggle('pp-switch--disabled', locked);
    });
  }
  function beginOperation() {
    activeOperations += 1; applyLockState();
    if (safetyUnlockTimer) clearTimeout(safetyUnlockTimer);
    safetyUnlockTimer = setTimeout(() => { safetyUnlockTimer = null; activeOperations = 0; applyLockState(); }, SAFETY_UNLOCK_MS);
  }
  function endOperation() {
    activeOperations = Math.max(0, activeOperations - 1);
    if (activeOperations === 0 && safetyUnlockTimer) { clearTimeout(safetyUnlockTimer); safetyUnlockTimer = null; }
    applyLockState();
  }

  const fetchCart = () => fetch('/cart.js').then((r) => r.json());
  const cartHasProtection = (cart) => cart.items.some((i) => i.variant_id === VID);
  const normalItemQuantity = (cart) => cart.items.reduce((s, i) => (i.variant_id === VID ? s : s + i.quantity), 0);

  /* Header count: real products only. The theme writes cart.item_count into <cart-count>; correct it afterwards. */
  function paintCount() {
    if (normalCountShown === null) return;
    document.querySelectorAll('cart-count').forEach((el) => { if (el.textContent.trim() !== String(normalCountShown)) el.textContent = normalCountShown; });
  }
  function showNormalCount(cart) { normalCountShown = normalItemQuantity(cart); paintCount(); }
  new MutationObserver(paintCount).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  function updateToggleState(cart) {
    const on = cartHasProtection(cart);
    document.querySelectorAll(SWITCH_SELECTOR).forEach((t) => { t.checked = on; });
  }

  function reloadIfCartPage() { if (ON_CART_PAGE && changedByUs) { changedByUs = false; location.reload(); } }

  function refreshCartDrawer(cart) {
    showNormalCount(cart);
    const cartDrawer = document.querySelector('cart-drawer');
    const wrap = cartDrawer && cartDrawer.closest('[id^="shopify-section-"]');
    const sectionId = wrap && wrap.id;
    if (!cartDrawer || !sectionId) { applyLockState(); return Promise.resolve(); }
    return fetch(Shopify.routes.root + '?section_id=' + sectionId)
      .then((r) => r.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const sectionElement = html.getElementById(sectionId);
        const fresh = sectionElement && sectionElement.querySelector('cart-drawer');
        if (fresh) cartDrawer.replaceChildren(...fresh.children);
        else if (sectionElement) cartDrawer.innerHTML = sectionElement.innerHTML;
        cartDrawer.classList.toggle('drawer--center-body', cart.item_count === 0);
        applyLockState();
      });
  }

  function afterChange(updatedCart) {
    updateToggleState(updatedCart);
    previousNormalItemCount = normalItemQuantity(updatedCart);
    return refreshCartDrawer(updatedCart).then(() => { hideCheckoutLoader(); reloadIfCartPage(); });
  }

  function runCartUpdate() {
    return fetchCart().then((cart) => {
      const normalQty = normalItemQuantity(cart);
      const hasProtection = cartHasProtection(cart);

      if (!hasInitialized) {
        hasInitialized = true;
        if (normalQty > 0 && !hasProtection && autoAddAllowed()) {
          changedByUs = true;
          return addProtection().then(fetchCart).then(afterChange);
        }
        if (normalQty === 0 && hasProtection) { changedByUs = true; return removeProtection().then(fetchCart).then(afterChange); }
        previousNormalItemCount = normalQty;
        updateToggleState(cart);
        return refreshCartDrawer(cart).then(hideCheckoutLoader);
      }
      if (normalQty === 0 && hasProtection) { changedByUs = true; return removeProtection().then(fetchCart).then(afterChange); }
      if (normalQty > previousNormalItemCount && !hasProtection && autoAddAllowed()) { changedByUs = true; return addProtection().then(fetchCart).then(afterChange); }
      previousNormalItemCount = normalQty;
      updateToggleState(cart);
      return refreshCartDrawer(cart).then(hideCheckoutLoader);
    }).catch((e) => { hideCheckoutLoader(); console.error('Package protection update failed:', e); });
  }

  function updateCartAndDrawer() { beginOperation(); return runCartUpdate().then(endOperation, endOperation); }

  function syncProtectionState() {
    return fetchCart().then((cart) => {
      updateToggleState(cart);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return cart;
    });
  }

  function priceSpan() { return document.querySelector('.et-cart-row--total span:last-child, .cart-drawer__button-price'); }
  function showCheckoutLoader() {
    const s = priceSpan(); if (!s || s.dataset.loading) return;
    s.dataset.loading = 'true'; s.dataset.original = s.innerHTML;
    s.innerHTML = '<span class="pp-loader"><i></i><i></i><i></i></span>';
  }
  function hideCheckoutLoader() {
    const s = priceSpan(); if (!s || !s.dataset.loading) return;
    s.innerHTML = s.dataset.original; delete s.dataset.loading; delete s.dataset.original;
  }

  function addProtection() {
    showCheckoutLoader();
    const body = new URLSearchParams(); body.append('id', VID); body.append('quantity', '1');
    return fetch('/cart/add.js', { method: 'POST', body: body }).then((r) => r.json()).then(syncProtectionState);
  }
  function removeProtection() {
    showCheckoutLoader();
    return fetchCart().then((cart) => {
      const item = cart.items.find((i) => i.variant_id === VID);
      if (!item) return cart;
      const body = new URLSearchParams(); body.append('id', item.key); body.append('quantity', '0');
      return fetch('/cart/change.js', { method: 'POST', body: body }).then((r) => r.json());
    }).then(syncProtectionState);
  }

  function handleSwitchChange(evt) {
    evt.preventDefault();
    const el = evt.target;
    if (isProcessing()) { el.checked = !el.checked; applyLockState(); return; }
    const on = el.checked;
    rememberChoice(on);
    document.querySelectorAll(SWITCH_SELECTOR).forEach((s) => { s.checked = on; });
    beginOperation();
    changedByUs = true;
    Promise.resolve(on ? addProtection() : removeProtection())
      .then(fetchCart).then(afterChange)
      .then(endOperation)
      .catch((e) => {
        console.error('Protection toggle failed, reverting:', e);
        document.querySelectorAll(SWITCH_SELECTOR).forEach((s) => { s.checked = !on; });
        endOperation();
      });
  }

  document.addEventListener('change', (evt) => { if (evt.target.classList && evt.target.classList.contains('pp-input')) handleSwitchChange(evt); });
  document.addEventListener('click', (evt) => {
    if (!isProcessing()) return;
    if (evt.target.closest && evt.target.closest('.pp-switch')) { evt.preventDefault(); evt.stopPropagation(); }
  }, true);
  document.addEventListener('cart:change', updateCartAndDrawer);
  document.addEventListener('cart:refresh', updateCartAndDrawer);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateCartAndDrawer); else updateCartAndDrawer();
})();
